import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { Login, Main, Router, Signup } from "./containers";
import { UserContextProvider } from "./contexts/userContext";

function App() {
  return (
    <BrowserRouter basename="/me">
      <UserContextProvider>
        <Router />
      </UserContextProvider>
    </BrowserRouter>
  );
}

export default App;
